"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopIn = exports.PopOut = exports.PopDirection = void 0;
var react_1 = __importDefault(require("react"));
var PopDirection;
(function (PopDirection) {
    PopDirection["TopLeft"] = "+top-left";
    PopDirection["TopRight"] = "+top-right";
    PopDirection["BottomRight"] = "+bottom-right";
    PopDirection["BottomLeft"] = "+bottom-left";
})(PopDirection = exports.PopDirection || (exports.PopDirection = {}));
var PopOut = function (props) {
    var direction = props.direction, fullWidth = props.fullWidth, fullHeight = props.fullHeight, className = props.className, divProps = __rest(props, ["direction", "fullWidth", "fullHeight", "className"]);
    var classes = [direction];
    if (fullWidth) {
        classes.push("+full-width");
    }
    if (fullHeight) {
        classes.push("+full-height");
    }
    className && classes.push(className);
    return react_1.default.createElement("div", __assign({ className: "c-pop-out " + classes.join(" ") }, divProps));
};
exports.PopOut = PopOut;
var PopIn = function (props) {
    var direction = props.direction, className = props.className, divProps = __rest(props, ["direction", "className"]);
    var classes = [direction];
    className && classes.push(className);
    return react_1.default.createElement("div", __assign({ className: "c-pop-in " + classes.join(" ") }, divProps));
};
exports.PopIn = PopIn;
//# sourceMappingURL=Pop.js.map